module.exports = __webpack_public_path__ + "img/milk_bg@2x.861d22ef.png";